import React from 'react';
import { IconSvgProps } from '@models/common';

const Download: React.FC<IconSvgProps> = (props) => {
  const { size = 20, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.6683 13.5184H3.33496M4.6669 8.16849L8.00023 11.5018M8.00023 11.5018L11.3336 8.16849M8.00023 11.5018L8.00023 2.6665'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Download;
